import { render, staticRenderFns } from "./jobDetail.vue?vue&type=template&id=93616b3e&scoped=true"
import script from "./jobDetail.vue?vue&type=script&lang=js"
export * from "./jobDetail.vue?vue&type=script&lang=js"
import style0 from "./jobDetail.vue?vue&type=style&index=0&id=93616b3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93616b3e",
  null
  
)

export default component.exports